export class CreditCardNumberValueConverter {
    toView(value: string, creditCardType: number): string {
        switch (creditCardType) {
        case 0:
        case 1:
        case 2:
            return `**** **** **** ${value} `;
        case 3:
            return `**** ****** *${value} `;
        default:
            return value;
        }
    }
}